module.exports = __webpack_public_path__ + "img/payment-method.b4c06ad0.svg";